import lokiDB from "./lokiDB";
import {
    getModificationTime,
    insertInto,
    setModificationTime,
} from "../utils/LokiUtils";

class SalesDB {
    getModificationTime(FarmID) {
        return getModificationTime("sales", "FarmID", FarmID);
    }

    /**
     * Funkcja dodajaca sprzedaze do bazy i aktualizujaca date modyfikacji
     *
     * Data modyfikacji trzymana jest per ferma, poniewaz endpoint zwraca dane tylko dla jednej fermy.
     * Wspolny kursor dla wszystkich farm powodowal, ze sync jednej fermy przesuwal kursor innej
     * i jej sprzedaze nigdy juz nie zostaly pobrane.
     *
     * @param values tablica sprzedazy
     */
    insertSales(values) {
        values.sort((e1, e2) => e1.DtaModTime - e2.DtaModTime);
        insertInto(values, lokiDB.sales, "SaleID");
        const newest = values[values.length - 1];
        setModificationTime(
            "sales",
            newest.DtaModTime,
            "FarmID",
            newest.FarmID
        );
    }

    getSales(FarmID) {
        return lokiDB.sales.find({
            FarmID,
            DtaDelTime: {$type: "undefined"},
        });
    }

    getSaleByID(SaleID) {
        return lokiDB.sales.findOne({
            SaleID,
            DtaDelTime: {$type: "undefined"},
        });
    }

    getAllSales(FarmID) {
        return lokiDB.sales.find({
            FarmID,
        });
    }
}

const salesDB = new SalesDB();
export default salesDB;
